import { useEffect } from "react";

export const useClickOutside = (
  ref: (HTMLElement | null)[],
  onClick: () => void,
  isActive: boolean
) => {
  useEffect(() => {
    if (!isActive) {
      return;
    }

    const clickOutsideElement = (event: MouseEvent): void => {
      for (let i = 0; i < ref.length; i++) {
        if (!ref[i]) continue;
        if (ref[i]?.contains(event.target as Node | null)) return;
      }

      onClick();
    };

    document.addEventListener("mousedown", clickOutsideElement);

    return () => {
      document.removeEventListener("mousedown", clickOutsideElement);
    };
  }, [ref, onClick, isActive]);
};
